import { useCallback, useState } from "react";
import { throwResponseError } from "../../../utils/api-error-utils";
import { getAuthParams } from "../../../utils/pacto-rebates-utils";
import { buildParams } from "../../utils/admin-utils";
import { formatSegmentationResponse } from "../../utils/segmentation-utils";

export function useSegmentations() {
    const [segmentations, setSegmentations] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const fetchSegmentations = useCallback(async (pagination = {}) => {
        try {
            setLoading(true);
            setError(null);

            const {
                accessToken,
                clientId
            } = getAuthParams();

            const params = buildParams(pagination);

            const requestOptions = {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "access_token": accessToken,
                    "client_id": clientId
                }
            };

            const response = await fetch(
                process.env.REACT_APP_ESSILOR_API +
                    `pacto-rebates-admin/v1/segmentacoes?${params.toString()}`,
                requestOptions
                
            );

            if (!response.ok) {
                await throwResponseError(response, "Erro ao buscar segmentações.");
            }

            const data = await response.json();
            const segmentationData = data.resultado || [];

            const responsePagination = {
                totalElements: data.totalElementos ?? 0,
                totalPages: data.totalPaginas ?? 0,
                page: data.pagina ?? 0,
                size: data.tamanho ?? pagination.size ?? 10
            };

            const formattedSegmentations = Array.isArray(segmentationData)
                ? segmentationData.map(formatSegmentationResponse)
                : [];

            setSegmentations(formattedSegmentations);

            return {
                ok: true,
                empty: formattedSegmentations.length === 0,
                segmentations: formattedSegmentations,
                pagination: responsePagination
            };
        } catch (requestError) {
            setSegmentations([]);
            setError(requestError.message);

            return {
                ok: false,
                reason: "request",
                error: requestError.message
            };
                } finally {
            setLoading(false);
        }
    }, []);

    return {
        segmentations,
        loading,
        error,
        refetch: fetchSegmentations
    };
}